export default "__VITE_ASSET__9342c80c__"